<div class="container">
  <nav class="row fixed-top dateretrievedstyle">
    @if (totalSuccessCount > 0 || totalFailCount > 0) {
      <div
        class="alert alert-info"
        >
        @if (totalSuccessCount > 0) {
          <strong
            >{{ totalSuccessCount }} Observation(s) submitted Successfully.
          </strong>
        }
        @if (totalFailCount > 0) {
          <strong
            >{{ totalFailCount }} Observation(s) failed to Submit
          </strong>
        }
      </div>
    }
    <div class="col-md-12 date-label">
      <strong>Date Range</strong>: {{ startDate | date : "MM/dd/yyyy" }} &rarr; {{ endDate | date : "MM/dd/yyyy" }}
      <button class="clearButton btn btn-primary float-end buttonColor" (click)="clearFilters()">Reset Filter</button>
    </div>
  </nav>

  <div class="fixed_header" >
    <table mat-table [dataSource]="filterData()" class="table table-striped margintop20">
      <!-- Vital Sign Column -->
      <ng-container matColumnDef="vitalsign">
        <th class="headerFont" mat-header-cell *matHeaderCellDef>
          Vital Sign
          <!-- Dropdown for vital-sign filter in header -->
          <mat-select class="fontOption filterWidth"
            (selectionChange)="filterVitalSign($event)"
            placeholder="Select Vital Sign" #vitalSelector
            >
            <mat-option class="fontOption filterWidth" [value]="''"> All Vital Signs </mat-option>
            @for (vitals of vitalsignOptions; track vitals) {
              <mat-option class="fontOption filterWidth" [value]="vitals">
                {{vitals}}
              </mat-option>
            }
          </mat-select>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element?.resource?.code?.text  }}
        </td>
      </ng-container>

      <!-- Value Column -->
      <ng-container matColumnDef="value">
        <th class="headerFont" mat-header-cell *matHeaderCellDef>
          <div class="raiseHeader">Value </div></th>
          <td mat-cell *matCellDef="let element">
            <span>{{ getNodeValue($safeNavigationMigration(element?.resource)) }}</span>
            <span>{{ getComponentValue($safeNavigationMigration(element?.resource?.component)) }}</span>
          </td>
        </ng-container>

        <!-- Date Column -->
        <ng-container matColumnDef="date">
          <th class="headerFont" mat-header-cell *matHeaderCellDef>
            <span>Date/Time</span>
            <!-- Dropdown for date filter in header -->
            <mat-select class="fontOption filterWidth"
              (selectionChange)="filterDate($event)"
              placeholder="Select Date/Time" #dateSelector
              >
              <mat-option class="fontOption filterWidth" [value]="''">All Dates</mat-option>
              @for (date of dateOptions; track date) {
                <mat-option class="fontOption filterWidth" [value]="date">
                  {{date}}
                </mat-option>
              }
            </mat-select>
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element?.resource?.effectiveDateTime }}
          </td>
        </ng-container>

        <!-- Checkbos Column -->
        <ng-container matColumnDef="select">
          <th class="headerFont" mat-header-cell *matHeaderCellDef>
            <input class="raiseHeader"
              type="checkbox"
              [(ngModel)]="isAllSelected"
              (ngModelChange)="selectAll()"
              [disabled]="isAlldisabled"
              />
          </th>
          <td mat-cell *matCellDef="let element">
            <input
              type="checkbox"
              [(ngModel)]="element.selected"
              (ngModelChange)="toggleOption()"
              [disabled]="element.state == 'lighter'"
              />
          </td>
        </ng-container>

        <!--Set up order of headers and columns-->
        <tr
          mat-header-row
          *matHeaderRowDef="['vitalsign', 'value', 'date', 'select']"
        ></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: ['vitalsign', 'value', 'date', 'select']"
          [style.font-weight]="row.state"
        ></tr>
      </table>
    </div>
  </div>

  <div class="row top-buffer float-end adjustSubmitBtn">
    <button
      type="button"
      class="btn btn-primary submit-btn"
      (click)="submitToCibmtr()"
      enabled
      >
      Submit to CIBMTR
    </button>
  </div>
